import { ref, type Ref } from 'vue'

export interface ShareModalData {
  title: string
  text: string
  url: string
}

const shareData: Ref<ShareModalData | null> = ref(null)

export function useShareModal() {
  const openShareModal = (data: ShareModalData) => {
    shareData.value = { ...data }
  }

  const closeShareModal = () => {
    shareData.value = null
  }

  return {
    shareData,
    openShareModal,
    closeShareModal
  }
}
